export const toTwoDigits = (num: number) => {
    return ('0' + num).slice(-2);
};

export const clamp = (value: number, min: number, max: number) => {
    return Math.max(Math.min(value, max), min);
};
